import { render, staticRenderFns } from "./sme-preimum.vue?vue&type=template&id=740dfe6e&scoped=true&"
import script from "./sme-preimum.vue?vue&type=script&lang=js&"
export * from "./sme-preimum.vue?vue&type=script&lang=js&"
import style0 from "./sme-preimum.vue?vue&type=style&index=0&id=740dfe6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740dfe6e",
  null
  
)

export default component.exports